module.exports = __webpack_public_path__ + "static/img/lab2.31605cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/lab2.png
// module id = YOAD
// module chunks = 2